// import Logo from "../../../assets/images/empresa/IsoLogoColor.svg";
import Hamburguer from "../../../assets/images/generico/Hamburguer";
import HeaderTimer from "../HeaderTimer/HeaderTimer";
import { getStrDate } from "../../../../global/utils/diasData";
import React, { useContext, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import "./HeaderbarBeneficios.css";
import { HeaderBarBnfContainer, MenuContainerMobile } from "./localStyle";
import isIosNative from "../../../../global/utils/isIosNative";
import { getPlatforms, IonSpinner } from "@ionic/react";
import LoginIcon from "_+_Portal/assets/images/generico/LoginIcon";
import AlertIcon from "_+_Portal/assets/images/generico/AlertIcon";

const HeaderbarBeneficios = ({ onShowBurguerHandle, beneficios }) => {
  const { notificacionesState } = useContext(PortalContext);
  const [iosInfo, setIosInfo] = useState(false);
  async function infoIos() {
    const isIosNativeMobile = await isIosNative.logDeviceInfo();
    setIosInfo(isIosNativeMobile);
    return isIosNativeMobile;
  }
  infoIos();
  const [showDropPerfil, setShowDropPerfil] = useState(false);

  const onHandleClickAvatar = () => {
    if (!showDropPerfil) {
      setShowDropPerfil(true);
    } else {
      setShowDropPerfil(false);
    }
  };

  // ----------------- Notificaciones --------------------
  let config = localStorage.getItem("config");
  let opcNoti = JSON.parse(config).opcNotificaciones;

  let notiData = notificacionesState.notificaciones?.data;
  let notifiacionesNoLeidas = notiData
    ? notiData?.filter(
        (element) =>
          !element.fechavisto || element.fechavisto === "0001-01-01T00:00:00"
      )
    : [];

  // ----------------- Notificaciones --------------------

  return (
    <React.Fragment>
      <div className="ptur-headerBeneficiosContainer">
        <div className="preHeader">
          <AlertIcon color={"var(--color-white)"} /> Hace un test para COVID -
          19 (RT-PCR)
        </div>
        <div
          className={`ptur-HeaderbarDivBeneficios-background ${
            !showDropPerfil ? "disable" : ""
          }`}
          onClick={onHandleClickAvatar}
        ></div>
        <HeaderBarBnfContainer className="c-white" $isIos={iosInfo}>
          <div className="logoHeader">
            <img
              className="ptur-logoHeader"
              src={
                process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"
              }
              alt="logo"
            ></img>
          </div>
          <div className="ptur-RightMenu">
            {beneficios ? (
              <div className="ptur-beneficiosHeader-container">
                <button className="ptur-btnBeneficios-volver rb18m bgc-white c-latex30">
                  Volver al sitio
                </button>
                <button className="ptur-btnBeneficios-portal rb18m bgc-primary c-white">
                  <LoginIcon />
                  Portal de turnos
                </button>
                <button className="ptur-btnBeneficios-socio rb18m bgc-white c-latex30">
                  Quiero ser socio
                </button>
                <div
                  onClick={onShowBurguerHandle}
                  className="ptur-burguerPerfilBeneficios pointer"
                >
                  <MenuContainerMobile>
                    <Hamburguer />
                    {notificacionesState.notificaciones.data &&
                    opcNoti &&
                    notifiacionesNoLeidas.length > 0 ? (
                      <div className="number-circle">
                        {notifiacionesNoLeidas.length}
                      </div>
                    ) : notificacionesState.notificaciones.loading ? (
                      <div className="number-circle">
                        {
                          <span>
                            <IonSpinner name="lines" />
                          </span>
                        }
                      </div>
                    ) : (
                      ""
                    )}
                  </MenuContainerMobile>
                </div>
              </div>
            ) : (
              <>
                {/* {opcNoti ? (
                  <ContainerNoti>
                    <Link to="/notificaciones" className="circle">
                      <NotifiacionIcon color="#fff" />
                      {notificacionesState.notificaciones.data &&
                      opcNoti &&
                      notifiacionesNoLeidas.length > 0 ? (
                        <div className="number-circle">
                          {notifiacionesNoLeidas.length}
                        </div>
                      ) : notificacionesState.notificaciones.loading ? (
                        <div className="number-circle">
                          {
                            <span>
                              <IonSpinner name="lines-small" />
                            </span>
                          }
                        </div>
                      ) : (
                        ""
                      )}
                    </Link>
                  </ContainerNoti>
                ) : (
                  ""
                )} */}
                <div className="ptur-headerBarHome-txtDiaHora">
                  <p id="ptur-DiaResponsive" className="rb18m">
                    {getStrDate(new Date())}
                    <span className="ptur-timer">
                      <HeaderTimer />
                    </span>
                  </p>
                </div>
              </>
            )}
          </div>
        </HeaderBarBnfContainer>
      </div>
    </React.Fragment>
  );
};

export default HeaderbarBeneficios;
